import React from 'react'
import { Button, SxProps } from '@mui/material'
import { makeStyles } from '@mui/styles'
import AddIcon from '@mui/icons-material/Add'

import { buttonStyle } from '../../global'

const useStyles = makeStyles({
  buttonDesign: {
    boxShadow: 'none',
    '&:hover': {
      background: '#253D82'
    }
  }
})

export interface ButtonProps {
  /**
   * Is this the principal call to action on the page?
   */
  primary?: boolean
  icon?: boolean
  /**
   * What background color to use
   */
  backgroundColor?: string
  color?: string
  /**
   * How large should the button be?
   */
  size?: 'small' | 'medium' | 'large'
  /**
   * Button contents
   */
  label: string
  /**
   * Optional click handler
   */
  fontSize?: number
  onClick?: () => void

  disabled?: boolean
  variant?: any
  fullWidth?: boolean
  cursor?: string
  borderColor?: string
  width?: string
  sx?: SxProps
}

/**
 * Primary UI component for user interaction
 */
export const ButtonCustom: React.FC<ButtonProps> = ({
  primary = false,
  size = 'medium',
  backgroundColor,
  label,
  color,
  icon = true,
  variant,
  disabled = false,
  fullWidth = false,
  width = 'auto',
  cursor = 'default',
  borderColor = 'none',
  sx,
  ...props
}) => {
  const classes = useStyles()

  // style = { buttonStyle }

  return (
    <Button
      startIcon={icon && <AddIcon />}
      type='button'
      sx={{ ...buttonStyle, ...sx }}
      className={classes.buttonDesign}
      style={{ backgroundColor, color, borderColor, width }}
      fontSize='14px !important'
      disabled={disabled}
      variant={variant}
      fullWidth={fullWidth}
      {...props}
    >
      {label}
    </Button>
  )
}
